import thumbnailImg from 'Static/thumbnails/screenshot--coral-reef.png';

export default {
  slug: 'coral-reef',
  title: 'Coral Reef',
  seriesNumber: '10',
  published: true,
  thumbnailImg,
  isNew: false,
  subject: '',
  graphicFileName: 'Image_CoralReef.png',
  graphicAlt: '',
  iconFileName: 'Icon_CoralReef.png',
  iconLargeFileName: 'Icon_CoralReef@2x.png',
  iconAlt: '',
  description:
    'Topics covered include energy food and flow chains, animal diets, trophic levels, energy, food webs, and animal adaptations.',
  briefDescription: '',
  supportedLanguages: [
    'en',
    'ar',
    'da',
    'de',
    'el',
    'es',
    'fi',
    'fr',
    'hi',
    'it',
    'ja',
    'ko',
    'ms',
    'nb',
    'nl',
    'pt',
    'ru',
    'sv',
    'th',
    'tr',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'Main_Scene',
    'CU_Scene_Producer',
    'CU_Scene_Cleaning',
    'CU_Scene_Parrotfish',
    'CU_Scene_Jellyfish_Food',
    'CU_Scene_Shrimp_Attack',
    'CU_Scene_Shark_Food',
    'CU_Scene_Decomposer',
  ],
  featuredPrintables: ['coralreef_food_web'],
  printables: [
    'coralreef_food_chains',
    'coralreef_investigate',
    'generating_questions',
    'concept_map',
  ],
  topics: [
    'coralreef_jellyfish',
    'coralreef_seagrass',
    'coralreef_sharkfeeding',
    'coralreef_peacockshrimp',
  ],
  deepLinks: {
    jellyfish: 'CU_Scene_Jellyfish_Food',
    shark: 'CU_Scene_Shark_Food',
    'mantis-shrimp': 'CU_Scene_Shrimp_Attack',
    'cleaner-fish': 'CU_Scene_Cleaning',
    seagrass: 'CU_Scene_Producer',
    parrotfish: 'CU_Scene_Parrotfish',
    'sea-star': 'CU_Scene_Decomposer',
  },
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/coral-reef-by-tinybop/id1331577768',
  },
};
